// Content configuration for the Tanishq-style home layout.
// All images use public Unsplash / Pexels URLs. Update / replace anytime.

export const HERO_MAIN =
  "https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?auto=format&fit=crop&w=1400&q=85"; // model with jewellery
export const HERO_PRODUCT =
  "https://images.unsplash.com/photo-1714733831162-0a6e849141be?auto=format&fit=crop&w=800&q=85"; // jhumka closeup
export const HERO_PRODUCT_NAME = "Dazzling Teardrop Gold Jhumkas";

// Category bar under header
export const TOP_NAV = [
  { label: "All Jewellery", to: "/#collections", eyebrow: true },
  { label: "Gold", to: "/collections/gold" },
  { label: "Silver", to: "/collections/silver" },
  { label: "Rose Gold", to: "/collections/rose-gold" },
  { label: "Diamond", to: "/collections/diamond" },
  { label: "Gemstones", to: "/collections/gemstones" },
  { label: "Temple & Antique", to: "/collections/temple-antique" },
  { label: "New Arrivals", to: "/style/new" },
  { label: "Daily Wear", to: "/style/daily-wear" },
];

// Shop by Categories — circular tiles
export const SHOP_CATEGORIES = [
  {
    label: "Earrings",
    to: "/collections/gold",
    image:
      "https://images.unsplash.com/photo-1714733831162-0a6e849141be?auto=format&fit=crop&w=400&q=80",
  },
  {
    label: "Rings",
    to: "/collections/gold",
    image:
      "https://images.unsplash.com/photo-1605100804763-247f67b3557e?auto=format&fit=crop&w=400&q=80",
  },
  {
    label: "Necklaces",
    to: "/collections/gold",
    image:
      "https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?auto=format&fit=crop&w=400&q=80",
  },
  {
    label: "Bangles",
    to: "/collections/gold",
    image:
      "https://images.pexels.com/photos/37485309/pexels-photo-37485309.jpeg?auto=compress&cs=tinysrgb&w=400",
  },
  {
    label: "Chains",
    to: "/collections/gold",
    image:
      "https://images.unsplash.com/photo-1611107683227-e9060eccd846?auto=format&fit=crop&w=400&q=80",
  },
  {
    label: "Pendants",
    to: "/collections/diamond",
    image:
      "https://images.unsplash.com/photo-1605884878538-6468614df578?auto=format&fit=crop&w=400&q=80",
  },
  {
    label: "Silver Murti",
    to: "/collections/silver",
    image:
      "https://images.unsplash.com/photo-1615719413546-198b25453f85?auto=format&fit=crop&w=400&q=80",
  },
  {
    label: "Bridal Sets",
    to: "/collections/temple-antique",
    image:
      "https://images.unsplash.com/photo-1601121141418-c1caa10a2a0b?auto=format&fit=crop&w=400&q=80",
  },
];

// Trending Now — rectangular cards, horizontally arranged
export const TRENDING = [
  {
    title: "Gifting Jewellery",
    tagline: "Under ₹ 25,000 — perfectly boxed",
    to: "/collections/gold",
    image:
      "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?auto=format&fit=crop&w=800&q=80",
    tag: "New",
  },
  {
    title: "Origami Edit",
    tagline: "Geometric folds in 18k gold",
    to: "/collections/rose-gold",
    image:
      "https://images.unsplash.com/photo-1622398925373-3f91b1e275f5?auto=format&fit=crop&w=800&q=80",
    tag: "Hot",
  },
  {
    title: "Everyday Diamond",
    tagline: "Wear-to-work solitaires",
    to: "/collections/diamond",
    image:
      "https://images.unsplash.com/photo-1693212793204-bcea856c75fe?auto=format&fit=crop&w=800&q=80",
  },
  {
    title: "Temple Revival",
    tagline: "Heritage kundan & polki",
    to: "/collections/temple-antique",
    image:
      "https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?auto=format&fit=crop&w=800&q=80",
  },
  {
    title: "Silver Statement",
    tagline: "92.5 sterling · bold & modern",
    to: "/collections/silver",
    image:
      "https://images.unsplash.com/photo-1639065643006-e217c4fee12e?auto=format&fit=crop&w=800&q=80",
  },
];

// Shop by Occasion — 4 large image tiles
export const OCCASIONS = [
  {
    label: "Wedding",
    caption: "Bridal sets that become heirlooms",
    to: "/collections/temple-antique",
    image:
      "https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?auto=format&fit=crop&w=900&q=85",
  },
  {
    label: "Festivals",
    caption: "Sparkle for Diwali, Karva Chauth & more",
    to: "/collections/gold",
    image:
      "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?auto=format&fit=crop&w=900&q=85",
  },
  {
    label: "Everyday",
    caption: "Light, wearable, effortless",
    to: "/collections/silver",
    image:
      "https://images.unsplash.com/photo-1611107683227-e9060eccd846?auto=format&fit=crop&w=900&q=85",
  },
  {
    label: "Gifting",
    caption: "For anniversaries and milestones",
    to: "/collections/diamond",
    image:
      "https://images.unsplash.com/photo-1605884878538-6468614df578?auto=format&fit=crop&w=900&q=85",
  },
];

// Find Your Perfect Match — quick pickers (linked to real destinations)
export const PERFECT_MATCH = [
  { label: "By Metal",    sub: "Gold · Silver · Rose · Diamond", icon: "gem",     to: "/collections/gold" },
  { label: "By Occasion", sub: "Wedding · Festive · Daily",      icon: "gift",    to: "/#occasions" },
  { label: "By Style",    sub: "Antique · Modern · Minimal",     icon: "sparkle", to: "/collections/temple-antique" },
];
